export default __webpack_public_path__ + "static/media/telegram.972d8234.svg";